import debounce from 'debounce';
class NewsletterTrigger extends HTMLElement {
  constructor() {
    super();
    this._previousFocus = null;
    this._targetSelector = 'a[href="#newsletter"]';
  }
  connectedCallback() {
    this._modal = document.querySelector('#newsletter__modal');
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener('click', this.handleClick);

    // Find all newsletter links and set attributes
    const newsletterLinks = document.querySelectorAll(this._targetSelector);
    newsletterLinks.forEach(link => this.setupNewsletterLink(link));

    // Add event listeners for modal open/close
    if (this._modal) {
      // Creating bound methods to ensure proper event removal
      this.boundHandleModalOpen = this.handleModalOpen.bind(this);
      this.boundHandleModalClose = this.handleModalClose.bind(this);

      // Use the custom events dispatched by the modal component
      this._modal.addEventListener('modal:opened', this.boundHandleModalOpen);
      this._modal.addEventListener('modal:closed', this.boundHandleModalClose);
    }
  }
  disconnectedCallback() {
    document.removeEventListener('click', this.handleClick);
    if (this._modal) {
      this._modal.removeEventListener('modal:opened', this.boundHandleModalOpen);
      this._modal.removeEventListener('modal:closed', this.boundHandleModalClose);
    }
  }
  setupNewsletterLink(link) {
    // Add attributes needed for controlling the modal
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'newsletter__modal');

    // Optionally add a data attribute to mark it as processed
    link.setAttribute('data-newsletter-trigger', 'true');
    link.setAttribute('aria-expanded', 'false');
  }
  handleModalOpen(event) {
    // Update aria-expanded attribute on all trigger elements
    const newsletterLinks = document.querySelectorAll(this._targetSelector);
    newsletterLinks.forEach(link => {
      link.setAttribute('aria-expanded', 'true');
    });
  }
  handleModalClose(event) {
    // Update aria-expanded attribute on all trigger elements
    const newsletterLinks = document.querySelectorAll(this._targetSelector);
    newsletterLinks.forEach(link => {
      link.setAttribute('aria-expanded', 'false');
    });
  }
  handleClick(event) {
    const target = event?.target?.closest(this._targetSelector);
    if (target) {
      event.preventDefault();
      this._modal?.open?.();
    }
  }
}
customElements.define('newsletter-trigger', NewsletterTrigger);